import { ApprovedApplicationState } from '../../Dashboard.types';
import { formatCurrency } from '../../utils/currency';
import { OfferChoiceForm } from '../OfferChoiceForm/OfferChoiceForm';

export const ApprovedApplication = ({
  application,
}: {
  application: ApprovedApplicationState;
}) => {
  return (
    <div className="flex flex-col gap-l">
      <div className="text-2xl font-bold sm:text-xl">
        You've been <span className="text-success-drk">approved</span> for this
        payment of {formatCurrency(application.payLink.amount)}
      </div>
      <OfferChoiceForm application={application} />
    </div>
  );
};
